import coruja from '../assets/img/pet/coruja.png'
import corujaAlegre from '../assets/img/pet/corujaAlegre.png'
import corujaBracosCruzados from '../assets/img/pet/corujaBracosCruzados.png'
import corujaDedoLevantado from '../assets/img/pet/corujaDedoLevantado.png'
import corujaFeliz from '../assets/img/pet/corujaFeliz.png'
import corujaMaosNaCintura from '../assets/img/pet/corujaMaosNaCintura.png'
import corujaProfessora from '../assets/img/pet/corujaProfessora.png'
import corujaProfessoraBrava from '../assets/img/pet/corujaProfessoraBrava.png'
import corujaProfessoraMaoNaCintura from '../assets/img/pet/corujaProfessoraMaoNaCintura.png'
import corujaSegurandoChapeu from '../assets/img/pet/corujaSegurandoChapeu.png'
import corujaVergonha from '../assets/img/pet/corujaVergonha.png'

export const typeOwl: { [key: string]: string } = {
    normal: coruja,
    dica: corujaDedoLevantado,
    atencao: corujaProfessora,
    erro: corujaVergonha,
    sucesso: corujaFeliz,
    alegre: corujaAlegre,
    brava: corujaBracosCruzados,
    chapeu: corujaSegurandoChapeu,
    professoraBrava: corujaProfessoraBrava,
};